import { Component, OnChanges, Input } from '@angular/core';
import { GenService } from '../../shared/gen-ser.service';
import { DataService } from '../../shared/dataservice.service';
import { PSMToken, ProductionStatusMonitoring, PSMDayToken } from '../../shared/misc-classes';

@Component({
  selector: 'app-prdtn-status',
  templateUrl: './prdtn-status.component.html',
  styleUrls: ['./prdtn-status.component.css']
})
export class PrdtnStatusComponent implements OnChanges {
  @Input() currMonthDtObj:Date;
  @Input() prodStatusObj:ProductionStatusMonitoring;  
  PSMDayTokenObj:PSMDayToken;
  constructor(private _dataService:DataService) { }

  ngOnChanges() {
    this.loadDateData();
  }
  getData(option){
    if(option) return option
    return '-'
  }
  getProductName(_prodId: string): string {
    if (_prodId)
      return this._dataService.getMainProduct(_prodId);
    return '';
  }
  calculate(name,date){ 
    if(name == 'scheduleMnth'){
      var sdmtkn = 0
      for(var i=0;i<this.PSMDayTokenObj.dateTokens.length;i++){
        if(this.PSMDayTokenObj.dateTokens[i].scheduleMnth){
          sdmtkn=  sdmtkn+Number(this.PSMDayTokenObj.dateTokens[i].scheduleMnth)
        }
      }
      return sdmtkn
    }
    if(name == 'tillDatePrdction'){
      var tdptkn = 0
      for(var i=0;i<this.PSMDayTokenObj.dateTokens.length;i++){
        if(this.PSMDayTokenObj.dateTokens[i].tillDatePrdction){
          tdptkn=  tdptkn+Number(this.PSMDayTokenObj.dateTokens[i].tillDatePrdction)
        }
      }
      return tdptkn
    }      
    if(name == 'balanceQty'){
      var bqtkn = 0
      for(var i=0;i<this.PSMDayTokenObj.dateTokens.length;i++){
        if(this.PSMDayTokenObj.dateTokens[i].balanceQty){
          bqtkn=  bqtkn+Number(this.PSMDayTokenObj.dateTokens[i].balanceQty)
        }
      }
      return bqtkn
    }      
    if(name == 'ystrdyProductin'){
      var ydptkn = 0
      for(var i=0;i<this.PSMDayTokenObj.dateTokens.length;i++){
        if(this.PSMDayTokenObj.dateTokens[i].ystrdyProductin){
          ydptkn=  ydptkn+Number(this.PSMDayTokenObj.dateTokens[i].ystrdyProductin)
        }
      }
      return ydptkn
    }      
    if(name == 'tdayProdctonPlan'){
      var tdpptkn = 0
      for(var i=0;i<this.PSMDayTokenObj.dateTokens.length;i++){
        if(this.PSMDayTokenObj.dateTokens[i].tdayProdctonPlan){
          tdpptkn=  tdpptkn+Number(this.PSMDayTokenObj.dateTokens[i].tdayProdctonPlan)
        }
      }
      return tdpptkn
    }
    
    if(name == 'dateTestedQty'){
      var dtqtkn = 0
      for(var i=0;i<this.PSMDayTokenObj.dateTokens.length;i++){
        if(this.PSMDayTokenObj.dateTokens[i].dateTestedQty){
          dtqtkn=  dtqtkn+Number(this.PSMDayTokenObj.dateTokens[i].dateTestedQty)
        }
      }
      return dtqtkn
    }
    if(name == 'dateGreenSticker'){
      var tgstkn = 0
      for(var i=0;i<this.PSMDayTokenObj.dateTokens.length;i++){
        if(this.PSMDayTokenObj.dateTokens[i].dateGreenSticker){
          tgstkn=  tgstkn+Number(this.PSMDayTokenObj.dateTokens[i].dateGreenSticker)
        }
      }
      return tgstkn
    }
    if(name == 'balanceGreenStickerQty'){
      var bgstkn = 0
      for(var i=0;i<this.PSMDayTokenObj.dateTokens.length;i++){
        if(this.PSMDayTokenObj.dateTokens[i].balanceGreenStickerQty){
          bgstkn=  bgstkn+Number(this.PSMDayTokenObj.dateTokens[i].balanceGreenStickerQty)
        }
      }
      return bgstkn
    }
}
  loadDateData():void{
    if(this.prodStatusObj){
      let _tmpDPHDayToken:PSMDayToken = this.prodStatusObj.getDateToken(this.currMonthDtObj);
      if(_tmpDPHDayToken == null){
        this.prodStatusObj.addDateToken(this.currMonthDtObj);  
        _tmpDPHDayToken = this.prodStatusObj.getDateToken(this.currMonthDtObj);
      }
      this.PSMDayTokenObj = _tmpDPHDayToken;
    }
    else{
      this.PSMDayTokenObj = new PSMDayToken(this.currMonthDtObj,[],[])
    }    
  }

}
